var React = require('react');

function StepBullePopin (props) {
    return React.createElement("svg",props,React.createElement("g",null,React.createElement("path",{"d":"M9.248,157.889c30.533-25.117,208.578,3.393,208.503-93.264C217.69,6.745,99.25-5.968,60.065,8.701\r\n\t\tc-15.854,6.416-39.182,26.583-38.242,45.828c0,25.671,19.406,46.835,10.85,66.901C28.3,131.687,26.777,143.465,9.248,157.889z"})));
}

StepBullePopin.defaultProps = {"version":"1.1","id":"Calque_1","x":"0px","y":"0px","viewBox":"0 0 220 200","xmlSpace":"preserve"};

module.exports = StepBullePopin;

StepBullePopin.default = StepBullePopin;



//////////////////
// WEBPACK FOOTER
// ./node_modules/svg-react-loader/lib/loader.js!./src/assets/step-bulle-popin.svg
// module id = 425
// module chunks = 0